import React from 'react';

const YoutubeUrlInput = ({ youtube_url, handleVideoUrlChange, handlePaste }) => {
  return (
    <div className="my-4">
      <label className="text-black font-medium">
        Enter your Youtube URL
      </label>
      <input
        className="w-full bg-white text-gray-900 border border-gray-400 mt-2 p-3 rounded-2xl hover:border-red-600 focus:border-red-700 focus:outline-none focus:shadow-outline"
        type="text"
        placeholder="https://www.youtube.com/watch-2/wertycf"
        value={youtube_url}
        onChange={handleVideoUrlChange}
        onPaste={handlePaste}
      />
    </div>
  );
};

export default YoutubeUrlInput;
